import { RailHomeIcon, RailServicesIcon } from '../Common/Icons';
import styles from './RailPlaceholderIcon.module.scss';

const ICONS = {
    home: RailHomeIcon,
    services: RailServicesIcon,
};

/**
 * A navigation rail entry whose module does not exist yet (FR59 hardcode).
 *
 * Rendered as a disabled, non-interactive item so the rail is complete without
 * pretending to navigate. Delete once the Home / Services modules ship.
 *
 * @param label Accessible name of the entry.
 * @param badge Count shown on the badge; omit or pass 0 to hide it.
 * @param variant Which icon to draw: "home" or "services".
 */
export default function RailPlaceholderIcon({ label, badge = 0, variant = 'home' }) {
    const Icon = ICONS[variant] || RailHomeIcon;
    const isServices = variant === 'services';

    return (
        <span className={`${styles.item} ${isServices ? styles.services : ''}`} role="img" aria-label={label}>
            {/* The badge overlaps the glyph, so it anchors to a box that wraps the glyph
             * rather than to the whole tile. */}
            <span className={styles.glyph}>
                <Icon />
                {badge > 0 && <span className={`${styles.badge} ${isServices ? styles.gold : ''}`}>{badge}</span>}
            </span>
            {!isServices && <span className={styles.label}>{label}</span>}
        </span>
    );
}
